import { ActionReducerMap } from '@ngrx/store';

export interface AppState {
  // Feature states are registered in their respective modules.
}

export const reducers: ActionReducerMap<AppState> = {
  // Root reducers
};
